import script from "./PassingOnLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./PassingOnLogo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__